import WorkSpaceLoading from '../loading/workSpaceLoading';
import { GroupWorkspaceLoading } from './style';
import { rootStore } from '../../mobx/rootStore';
import { DESKTOP_VIEW } from '../../global/constants';
import { isElectronApp } from '../../helpers/common';

interface Props {
  children?: any;
}

const LayoutWithoutNavbar: React.FC<Props> = (props) => {
  const { children } = props;
  // Mobx store
  const { appStore } = rootStore || {};
  const { extractedDesktopView, isAppLoading } = appStore || {};

  return (
    <>
      {isAppLoading ? (
        <GroupWorkspaceLoading extractedDesktopView={extractedDesktopView === DESKTOP_VIEW.OPEN && isElectronApp()}>
          <WorkSpaceLoading />
        </GroupWorkspaceLoading>
      ) : (
        children
      )}
    </>
  );
};

export default LayoutWithoutNavbar;
